module.exports = __webpack_public_path__ + "img/mainmenbuttonTH.c8b9c990.png";